module.exports = __webpack_public_path__ + "static/img/Lachie-Hunter.ec9e039.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie-Hunter.jpg
// module id = OJB8
// module chunks = 0